import { render, staticRenderFns } from "./OceanScoreChart.vue?vue&type=template&id=5a2b9707&scoped=true&"
import script from "./OceanScoreChart.vue?vue&type=script&lang=js&"
export * from "./OceanScoreChart.vue?vue&type=script&lang=js&"
import style0 from "./OceanScoreChart.vue?vue&type=style&index=0&id=5a2b9707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b9707",
  null
  
)

export default component.exports